import { render, staticRenderFns } from "./DontWorryUSPS.vue?vue&type=template&id=334b547e&scoped=true&"
import script from "./DontWorryUSPS.vue?vue&type=script&lang=js&"
export * from "./DontWorryUSPS.vue?vue&type=script&lang=js&"
import style0 from "./DontWorryUSPS.vue?vue&type=style&index=0&id=334b547e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334b547e",
  null
  
)

export default component.exports